import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

const ShadowDOMWrapper = ({ children, id }) => {
  const containerRef = useRef(null);
  const [shadowRoot, setShadowRoot] = useState(null);

  useEffect(() => {
    if (containerRef.current && !shadowRoot) {
      const shadow = containerRef.current.attachShadow({ mode: "open" });
      setShadowRoot(shadow); 
    }
  }, [shadowRoot]);



  if (shadowRoot) {
    if (!shadowRoot.querySelector('script[src="/viewpreview/js/jquery-ui-slider-pips.js"]')) {
      const script = document.createElement('script');
      script.src = "/viewpreview/js/jquery-ui-slider-pips.js";
      shadowRoot.appendChild(script);
    }
  }
  
  return (
    <div ref={containerRef} id={id} style={{height: 'auto'}}>
      {shadowRoot && ReactDOM.createPortal(children, shadowRoot)}
    </div>
  );
};

export default ShadowDOMWrapper;
